import { useEffect } from 'react';

export const useClickOutside = (ref, callback) =>
  useEffect(() => {
    const handleClick = event => {
      const isClickOutside = ref.current && !ref.current.contains(event.target);
      if (isClickOutside) {
        callback();
      }
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ref, callback]);
